/**
 * HTML-escape a string for safe inclusion inside an element body OR an
 * attribute value (single- and double-quoted alike).
 *
 * The codebase had several ad-hoc escape attempts (`(s).replace(/[<>&]/g, ...)`)
 * — these are not safe in attribute contexts because they leave `"` and
 * `'` untouched, so a payload like `" onerror="alert(1)` injected into
 * an attribute breaks out. Centralise the policy here and use it for
 * EVERY interpolation of user / API data into innerHTML / setHTML.
 *
 * See SCALING_AUDIT.md B-07.
 */
const HTML_ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[&<>"']/g, (c) => HTML_ESCAPE_MAP[c]!);
}
